<div class="demooz_item"
    [class.full_height]="this.fullHeight"
    >
    <ng-content></ng-content>
</div>